import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaProductoInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProducto.interface";
import { useToast } from "vue-toastification";
import { MarcaProductoCreateAction } from "../../actions/marcaActions";

const toast = useToast();

export function useMarcaProductoCreate(onClose?: () => void) {
  const queryClient = useQueryClient();

  // Mutation para crear la marca de vehÃ­culo
  const mutation = useMutation({
    mutationFn: (formData: FormData) =>
      MarcaProductoCreateAction(formData),

    onSuccess:async (response: ApiResponse<MarcaProductoInterface>) => {
     await queryClient.invalidateQueries({ queryKey: ["MarcaProductosList"] });
      toast.success("Marca de Productos creada correctamente");
      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al crear marca de Productos");
        if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
